module.exports = __webpack_public_path__ + "img/AdobeStock_177065225.19be8d16.jpeg";